import { CancelAdvanceRequest, AdvanceActions } from "../domain/advance";
import { cancelAdvanceService } from "../infrastructure/services/cancelAdvanceService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const cancelAdvance = {
  async execute(
    key: string,
    date: string,
    sellerCode: string,
    cancellationComments: string
  ): Promise<void> {
    const request: CancelAdvanceRequest =
      await AdvanceActions().advanceCancelRequest(
        key,
        date,
        sellerCode,
        cancellationComments
      );
    await cancelAdvanceService.execute(
      await tokenValidation.execute(),
      request
    );
  },
};
